import { useMemo } from 'react';
import type { RelatedCustomer } from '@appTypes/customerInformationType';
import useSelector from '@redux/typedHooks';

export const useHouseholdMembers = (): RelatedCustomer[] => {
  // Customers belong to a single household; we always read the first entry, as useMembershipStatus does.
  const households = useSelector((state) => state.myMembership.customerInformation.data?.households);

  // relatedCustomers lists relations, not people — one entry per relation role — so collapse per person.
  return useMemo(() => {
    const relatedCustomers = households?.[0]?.relatedCustomers || [];
    return [...new Map(relatedCustomers.map((customer) => [customer.customerId, customer])).values()];
  }, [households]);
};
